// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 5987 ? "buyCarMenu/details" : chunkId) + "." + {"1417":"c3df76a8cf5772af7b91","2880":"76eda041dac7144b51c1","3113":"1c91cd1e94d4f783b65a","3398":"7cc5860e905af5f675a7","5190":"43f135909a329653ef2c","5987":"c9b09e66f7114469d5b1"}[chunkId] + ".css";
};